// extracted by css-extract-rspack-plugin
export default {"carouselWrapper":"_fb7b1c08","moduleContainer":"_498d5e56","important":"_814d656d"};